import defaultTheme from 'tailwindcss/defaultTheme';
const flex = {
    flex: {
        ...defaultTheme.flex
    },
    flexShrink: {
        ...defaultTheme.flexShrink
    },
    flexGrow: {
        ...defaultTheme.flexGrow,
        '2': '2'
    },
    flexBasis: {
        ...defaultTheme.flexBasis
    }
};
export default flex;
